module.exports = __webpack_public_path__ + "static/media/norte_platea(1).325e4717.jpg";